import clsx from 'clsx';
import React from 'react';
import type { IconName } from '../../icons/types';
import Icon from '../Icon/Icon';

type HelperTextProps = {
  /** Optional decorative icon shown before the text. Rendered with aria-hidden. */
  icon?: IconName;
  id?: string;
  text: string;
};

function FormHelperText({ icon, id, text }: HelperTextProps): JSX.Element {
  return (
    <span id={id} className={clsx('helper-text', { 'helper-text--with-icon': icon })} aria-live="polite">
      {icon && <Icon name={icon} size="sm" />}
      {text}
    </span>
  );
}

export default FormHelperText;
